module.exports = __webpack_public_path__ + "static/img/10.fbb43e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/10.png
// module id = KfwY
// module chunks = 0